import type { RouteType, WriteRouteOptionsType } from './types/route-type';

// Die Startseite hat keinen eigenen Pfad: '#/' und ein leerer Hash sind beide home.
export const HOME_MODULE = 'home';
const HOME_HASH = '#/';

// Das erste Segment gehoert furnhome, der Rest geht als String an das Modul. Ein fehlender '/' nach
// dem '#' (`#administration`) wird geduldet - die Korrektur schreibt der Aufrufer per replace.
export function parseRoute(hash: string): RouteType {
  const path = hash.replace(/^#/, '').replace(/^\/+/, '');

  if (!path) {
    return { module: HOME_MODULE, subRoute: '' };
  }

  const separatorIndex = path.indexOf('/');

  if (separatorIndex === -1) {
    return { module: path, subRoute: '' };
  }

  return { module: path.slice(0, separatorIndex), subRoute: path.slice(separatorIndex + 1) };
}

export function formatRoute(route: RouteType): string {
  if (route.module === HOME_MODULE) {
    return HOME_HASH;
  }

  return route.subRoute ? `#/${route.module}/${route.subRoute}` : `#/${route.module}`;
}

export type RouteListenerType = (route: RouteType) => void;

// Die einzige Stelle, die location.hash anfasst. Gemeldet wird nur ein Hash, der sich vom zuletzt
// angewendeten unterscheidet - der eigene Schreibvorgang loest also keine Schleife aus.
export class HashRouter {
  private lastAppliedHash = '';

  private routeListener: RouteListenerType | undefined;

  public start(routeListener: RouteListenerType): void {
    this.routeListener = routeListener;
    this.lastAppliedHash = window.location.hash;
    window.addEventListener('hashchange', this.hashChanged);
  }

  public stop(): void {
    window.removeEventListener('hashchange', this.hashChanged);
    this.routeListener = undefined;
  }

  public readRoute(): RouteType {
    return parseRoute(window.location.hash);
  }

  public writeRoute(route: RouteType, options: WriteRouteOptionsType): void {
    const targetHash = formatRoute(route);

    if (!this.isCurrentHash(targetHash)) {
      if (options.replace) {
        window.history.replaceState(window.history.state, '', targetHash);
      } else {
        window.location.hash = targetHash;
      }
    }

    // Zurueckgelesen statt targetHash: der Browser darf Zeichen noch kodieren.
    this.lastAppliedHash = window.location.hash;
  }

  private isCurrentHash(targetHash: string): boolean {
    const currentHash = window.location.hash;
    return currentHash === targetHash || (targetHash === HOME_HASH && currentHash === '');
  }

  private hashChanged = (): void => {
    const currentHash = window.location.hash;

    if (currentHash === this.lastAppliedHash) {
      return;
    }

    this.lastAppliedHash = currentHash;
    this.routeListener?.(this.readRoute());
  };
}
